import { useDispatch, useSelector } from 'react-redux';
import GenericLineChart from '../../Charts/GenericLineChart';
import PerformanceCard from '../PerformanceCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceVisitEventsCard } from '@/store/slices/components/dashboard/service';
import getLineChartYStepValue from '../../utils/getLineChartYStepValue';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function DoneVisitsEvolution() {
  const dispatch = useDispatch();
  const {
    loading,
    hasFetched,
    value,
    variation,
    percentage_status,
    icon,
    labels,
    datasets,
  } = useSelector((state) => state.DashboardSlice.doneVisitsEvolution);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceVisitEventsCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'doneVisits',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard
      ref={ref}
      loading={loading || isStale}
      id="done-visits-evolution"
    >
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'VisitsMadeEvolution')}
      </PerformanceCard.Header>
      <PerformanceCard.Summary
        value={value}
        tendency={variation}
        icon={icon}
        percentageStatus={percentage_status}
      />
      <PerformanceCard.Content>
        <GenericLineChart
          labels={labels}
          datasets={datasets}
          yStepSize={getLineChartYStepValue(datasets[0]?.data)}
          autoSkip
        />
      </PerformanceCard.Content>
    </PerformanceCard>
  );
}
